export const INTERNAL_SERVER_ERROR_CODE = 500;
